export const SHADOW_CREATE_CARD_SKU = "character.shadow_create_card.v1";
export const SHADOW_CREATE_CARD_CASH_COST = 20_000;

export const SHADOW_AP_CARD_SKU = "character.shadow_ap_card.v1";
export const SHADOW_AP_CARD_CASH_COST = 10;

/** Starting AP budget for a new shadow (before any AP cards). */
export const SHADOW_BASE_AP = 20;

/** Extra AP per shadow AP card consumed on that shadow. */
export const SHADOW_AP_PER_CARD = 2;

export const SHADOW_DISPLAY_ALPHA = 0.6;
export const SHADOW_SCALE_MULTIPLIER = 2;
/** Render equipped shadow behind the follow sprite (rank badges use +2). */
export const SHADOW_DEPTH_BEHIND = 2;

export const SHADOWS_FIRESTORE_DOC = "playerShadows";
